import { render, staticRenderFns } from "./filesDragNDrop.vue?vue&type=template&id=b79a34d6&scoped=true&"
import script from "./filesDragNDrop.vue?vue&type=script&lang=js&"
export * from "./filesDragNDrop.vue?vue&type=script&lang=js&"
import style0 from "./filesDragNDrop.vue?vue&type=style&index=0&id=b79a34d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79a34d6",
  null
  
)

export default component.exports